module.exports = __webpack_public_path__ + "static/media/img2.6afab8e9.jpg";